var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col flex-1 overflow-hidden xbg-gray-100 bg-gradient-to-t from-gray-100 to-gray-200"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }